module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0042.jpg?v=d6c5c10a";